<div class="bg-white">
  <mat-dialog-content>
    <ng-content select="[content]"></ng-content>
  </mat-dialog-content>
  <mat-dialog-actions>
    <ng-content select="[content-actions]"></ng-content>
  </mat-dialog-actions>

</div>
